import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { useGame } from '@/app/providers/GameContextProvider';
import { useGameModeSettingsContext } from '@/app/providers/GameModeSettingsProvider';
import RoundConfig from './Config/RoundConfig';
import TextFFXIV from '@/app/components/TextFFXIV';
import TeamConfig from './Config/TeamConfig';

const CoopModeAdvancedSettings: React.FC = () => {
    const { t } = useTranslation();
    const { room, gameState } = useGame();
    const { isGameMaster } = useGameModeSettingsContext();

    if (!room || !gameState) return null;

    return (
        <div className={`flex flex-col gap-4 ${!isGameMaster ? 'opacity-50' : ''}`}>
            <TextFFXIV text={t('game.config.advancedSettings.title')} className="text-center" />
            <RoundConfig />
            <TeamConfig
                showMaxHP={false}
                showDamageMultiplier={false}
            />
        </div>
    );
};

export default CoopModeAdvancedSettings;
